/**
 * @Author: Zewei
 * @Date:   2018-02-11T16:55:36+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-28T17:49:47+08:00
 */

import React, { Component } from 'react';
import { Modal, Row, Col, Form, Select, Input, Button, TreeSelect, Spin } from 'antd';
import './style.less';

const FormItem = Form.Item;
const { Option } = Select;
const { TreeNode } = TreeSelect;

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
};
// const fiexSelectLayout = {
//     width: 231
// }
const userGroupType = [
    {
        type_id: 1,
        name: '日报',
    },
    {
        type_id: 2,
        name: '行销日报',
    },
    {
        type_id: 3,
        name: '周报',
    },
    {
        type_id: 4,
        name: '月报'
    }
]

class UserGroupCreateModal extends Component {

    constructor (props) {
    	super(props);
        this.createReportsFooter = [
            <div className="iconWrapper" key="close" onClick={props.handleModalCancel}>
                <Button type="primary" icon="close">关闭</Button>
            </div>,
            <div className="iconWrapper" key="close-circle" onClick={this.createGroup.bind(this)}>
                <Button type="primary" icon="check">提交</Button>
            </div>
        ];
        this.editReportsFooter = [
            <div className="iconWrapper" key="close" onClick={props.handleModalCancel}>
                <Button type="primary" icon="close">关闭</Button>
            </div>,
            <div className="iconWrapper" key="close-circle" onClick={this.updateGroup.bind(this)}>
                <Button type="primary" icon="check">确认编辑</Button>
            </div>
        ];
    }

    createGroup = () => {
        // 整合 post data
        this.props.createGroupList()
    }
    updateGroup = () => {
        this.props.updateGroupList()
    }

    renderTreeNodes = (data) => {
      // setInterval(() => console.log(data), 3000)
      return data.map((item) => {
        // console.log(item.children)
        // if (item.children && item.children.length > 0) {
        if (item.children) {
           // console.log(item.children)
          return (
            <TreeNode value={item.id + ""} title={item.name} key={item.id} dataRef={item}>
              { item.children.length !== 0 && this.renderTreeNodes(item.children) }
            </TreeNode>
          );
        }
        // delete item.children
        return <TreeNode key={item.id} title={item.name} value={item.id + ""} {...item} />;
      });
    }

    render() {
        const  { modalVisible, userList, groupListDetail, departmentsList, fetching,
                 handleModalCancel, handleSelectChange, handleUserGroupNameChange, handleUserGroupDepartmentChange, onSearchChange, handleReportTypeSelectChange } = this.props;

        // console.log(departmentsList);
        // const deleteChildren = data => {
        //   if (data.children && data.children.length > 0) {
        //     data.children.forEach(item => {
        //       deleteChildren(item)
        //     })
        //   }else{
        //     // delete data.children;
        //     data.children = null;
        //   }
        // }
        // deleteChildren({children: departmentsList})
        // console.log(departmentsList);

        let title = '新建群组',
            reportsFooter = this.createReportsFooter,
            employeesList = userList,
            groupMembers,
            defaultGroupUserIds;
        if (groupListDetail) {
            title = '编辑群组';
            reportsFooter = this.editReportsFooter;
            groupMembers = groupListDetail.group_members;
            employeesList = employeesList.concat(groupMembers);
            defaultGroupUserIds = groupMembers.map(i => {
              return `${i.employee_id}`;
            })
        }

        return (
            <Modal
             title={title}
             visible={modalVisible}
             onCancel={handleModalCancel}
             width={840}
             footer={reportsFooter}
             destroyOnClose={true}
             className="custom-modal"
           >
               <Row>
                   <Col md={12}>
                       <FormItem
                           {...formItemLayout}
                           label="群组名称"
                        >
                           <Input onChange={handleUserGroupNameChange} defaultValue={groupListDetail ? groupListDetail.name : ''} />
                       </FormItem>
                   </Col>
                   <Col md={12}>
                       <FormItem
                           {...formItemLayout}
                           label="所属部门"
                        >
                           {
                               departmentsList ?
                                   <TreeSelect
                                      // showSearch
                                      style={{ width: 230 }}
                                      // value={this.state.value}
                                      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                      placeholder="根据部门选择"
                                      allowClear
                                      treeDefaultExpandAll
                                      onChange={handleUserGroupDepartmentChange}
                                      defaultValue={groupListDetail ? `${groupListDetail.department_id}` : ''}
                                  >
                                       { this.renderTreeNodes(departmentsList) }
                                  </TreeSelect>
                                  :
                                  <Spin />
                           }
                       </FormItem>
                   </Col>
                   <Col md={12}>
                    <FormItem 
                         {...formItemLayout}
                         label="群组类型"
                    >
                        <Select style={{width: 231}} onChange={handleReportTypeSelectChange} defaultValue={groupListDetail ? `${groupListDetail.type_id}` : ''}>
                            {
                                userGroupType.map(i => (
                                    <Option key={i.type_id}>{i.name}</Option>
                                ))
                            }
                        </Select>
                    </FormItem>
                   </Col>
                   <Col md={24}>
                       <Col md={3} className="groupLabel">
                           查看人员
                       </Col>
                       <Col md={21}>
                           <Select
                               mode="multiple"
                               style={{ width: '100%' }}
                               placeholder="选择查看人员"
                               onSearch={onSearchChange}
                               onChange={handleSelectChange}
                               notFoundContent={fetching ? <Spin size="small" /> : null}
                               filterOption={false}
                               defaultValue={groupListDetail ? defaultGroupUserIds : []}
                           >
                                {
                                        employeesList.map(i => <Option key={i.id}>{i.real_name}</Option>)
                                }
                            </Select>
                       </Col>
                   </Col>
               </Row>
           </Modal>
        )
    }
}

export default UserGroupCreateModal;



// WEBPACK FOOTER //
// ./src/components/DailyReport/UserGroupModal.js